import { render } from "./LoadingFailed.vue?vue&type=template&id=2fd70e1e"
const script = {}

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__